<template>
    <base-widget>
        <template v-slot:default="{ schoolId }">
            <aftercare-list readonly :school-id="schoolId"></aftercare-list>
        </template>
    </base-widget>
</template>

<script>
    export default {
        name: 'PublicAftercareList',
        components: {
            BaseWidget:    () => import(/* webpackChunkName: "widgets"*/ './BaseWidget'),
            AftercareList: () => import(/* webpackChunkName: "widgets" */ '@/components/main/pages/aftercare/AftercareList')
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/main/widgets/PublicAftercareList.vue